import { render } from "./SonilinkHubsIndex.vue?vue&type=template&id=979c4914"
import script from "./SonilinkHubsIndex.vue?vue&type=script&lang=js"
export * from "./SonilinkHubsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__